module.exports = __webpack_public_path__ + "static/pinkcloudhamper-c895e4b79ca440f1b011c983e5761dc9.jpeg";